const features = [
  {
    title: 'One template. Every variant.',
    description: 'EN, FR, rep, broadcast — all from one source.',
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
      </svg>
    ),
    accent: 'blue',
  },
  {
    title: 'Error prevention, built in.',
    description: 'The formatting details that fail review? Handled.',
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    accent: 'emerald',
  },
  {
    title: 'Direct to Veeva',
    description: 'HTML + assets, uploaded together. No more clicking.',
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
      </svg>
    ),
    accent: 'violet',
    badge: 'Beta',
  },
];

const accentColors = {
  blue: {
    bg: 'bg-blue-600/10',
    text: 'text-blue-600',
    border: 'border-blue-600/20',
    hoverBorder: 'group-hover:border-blue-600/40',
  },
  emerald: {
    bg: 'bg-emerald-600/10',
    text: 'text-emerald-600',
    border: 'border-emerald-600/20',
    hoverBorder: 'group-hover:border-emerald-600/40',
  },
  violet: {
    bg: 'bg-violet-600/10',
    text: 'text-violet-600',
    border: 'border-violet-600/20',
    hoverBorder: 'group-hover:border-violet-600/40',
  },
};

export const Features = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Everything you need to ship faster
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Built specifically for teams who can't afford mistakes in regulated email campaigns.
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const colors = accentColors[feature.accent as keyof typeof accentColors];
            return (
              <div
                key={index}
                className={`group relative p-8 rounded-2xl bg-white border-2 ${colors.border} ${colors.hoverBorder} shadow-sm hover:shadow-lg transition-all duration-300`}
              >
                {/* Icon */}
                <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl ${colors.bg} ${colors.text} mb-6`}>
                  {feature.icon}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-3">
                  {feature.title}
                  {feature.badge && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-violet-100 text-violet-700">
                      {feature.badge}
                    </span>
                  )}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Corner accent */}
                <div className={`absolute top-0 right-0 w-16 h-16 ${colors.bg} rounded-bl-3xl rounded-tr-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
